import { SibBaseObject } from "../BaseObject/SibBaseObject";
import { Customer } from "../KYC/customer";


export class Group extends SibBaseObject {
    name: string;
    description: string;
    companies: string[] = [];
}
